import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { UserSession } from './user';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { HttpClient } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';
import { BrowserConfig } from '../config';
import { BrowserStorageService } from '../browser-storage.service';

const visitor: UserSession = {
  username: 'visitor',
  role: [],

  email: 'none',
  email_verified: false,
  phone_number: '000',
  sub: 's',
}

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private _user = new BehaviorSubject<UserSession>(visitor);

  public get user() {
    return this._user.asObservable();
  }
  public get userValue() {
    return this._user.value;
  }

  public get logged() {
    return this.userValue.username !== 'visitor';
  }

  public logout(showLogut = true) {
    firstValueFrom(this.oidcSecurityService.logoff()).then(() => {
      this.cleanLocalStorage();
      window.location.reload();
    })
  }

  async GoToLogin() {
    this.oidcSecurityService.authorize()
  }

  cleanLocalStorage() {
    Object.keys(localStorage).filter(fil => fil.includes('-' + BrowserConfig.openiddictsettings)).forEach(el => localStorage.removeItem(el))
  }

  init() {
    return new Promise<any>((resolve) => {
      if (isPlatformBrowser(this.platformid)) {
          this.oidcSecurityService
            .checkAuth()
            .subscribe(async (data) => {
              let isAuthenticated: boolean = data.isAuthenticated;
              let username = visitor.username;
              const userData: UserSession = data.userData;
              if (isAuthenticated) {
                username = userData.username
              } else {
                this.cleanLocalStorage();
              }
              const userSession = isAuthenticated ? userData : visitor;
              this._user.next(userSession);
              resolve(true);
            });
      } else {
        const user: UserSession = visitor
        resolve(true);
      }
    })
  }

  set lastUrl(val: string) {
    // sessionStorage.setItem('lastUrl', val);
    this.browserStorage.saveData('lastUrl', val, 'sessionStorage');
  }

  get lastUrl() {
    // return sessionStorage.getItem('lastUrl') ?? ''
    return this.browserStorage.getData('lastUrl', 'sessionStorage')
  }

  navigateByLastUrl() {
    this.router.navigateByUrl(this.lastUrl);
    this.lastUrl = '';
  }

  constructor(
    private oidcSecurityService: OidcSecurityService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformid: any,
    private http: HttpClient,
    private browserStorage: BrowserStorageService
  ) {
    if (isPlatformBrowser(platformid)) {
      this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          if (!event.url.includes('/Return'))
            this.lastUrl = event.url;
        }
      })
    }
  }

}
